<template>
  <ReactSiteFrame :src="src" />
</template>
<script>
import ReactSiteFrame from '../components/react/iframe'

export default {
  name: 'ComandaServicesReact',
  components: {
    ReactSiteFrame
  },
  data() {
    return {
      src: '/view/comanda/services'
    }
  }
}
</script>
